import { route, post, pageRoute } from "@utils/network";

export function prepareGCashRedirectionLinks(bookingId) {
    const bookingURL = pageRoute("bookings/:id", { id: bookingId });
    return {
        success: `${ bookingURL }?payment_status=authorized&payment_type=gcash`,
        failed: `${ bookingURL }`
    };
}

export function initializePayment(bookingId) {
    const redirectionLinks = prepareGCashRedirectionLinks(bookingId);
    const options = { data: { redirectionLinks } };

    return new Promise((resolve, reject) => {
        post(route("bookings/:id/initialize-gcash-payment", { id: bookingId }), options)
            .then(response => {
                resolve(response);
                const payload = response.data.result.payload;
                window.location.href = payload.attributes.redirect.checkout_url;
            })
            .catch(error => reject(error));
    });
}

export function registerPayment(bookingId) {
    return new Promise((resolve, reject) => {
        post(route("bookings/:id/register-gcash-payment", { id: bookingId }))
            .then(response => resolve(response))
            .catch(error => reject(error));
    })
    
}